import {redirect} from "react-router-dom";
import ProductCategories from "../../../services/UkTreatmentApi/ProductCategories";

export async function action({params}) {
    await ProductCategories.delete(params.productCategoryId);

    return redirect("/manage/product_categories");
}